import { all } from 'redux-saga/effects';

import type { SuperClientConfig } from '../api';

// The config threaded through every watcher: the super-client request config plus
// the local user database. Some watchers (verify-users-emails, un-phantom-users)
// require `db`, so the root config must carry it. `update`'s `id` is typed as
// `unknown` so this shape is assignable to those watchers' narrower configs.
interface RootSagaConfig extends SuperClientConfig {
  db: {
    users: {
      update: (id: unknown, user: unknown) => unknown;
    };
  };
}
import { watchArchiveActiveEot, watchFetchActiveEot } from './archive-active-eot';
import { watchBulkActions } from './bulk-actions';
import { watchFetchLicenses } from './fetch-licenses';
import { watchSearchLicenses } from './search-licenses';
import { watchCheckCostCenterName } from './check-cost-center-name';
import { watchCreateLicense } from './create-license';
import { watchFetchAllUsers } from './fetch-all-users';
import { watchFetchSearchUsers } from './fetch-search-users';
import { watchVerifyUsersEmails } from './verify-users-emails';
import { watchFetchCostCentersByUser } from './fetch-cost-centers-by-user';
import { watchUnPhantomUsers } from './un-phantom-users';
import {
  watchFetchProductVersions,
  watchUpdateProductWhitelist,
  watchCreateProductVersion,
  watchUpdateProductAssets,
  watchUpdateProductActive,
  watchFetchProductFeatures,
  watchFetchSeatFeatures,
  watchSetSeatFeature,
} from './product';
import {
  watchUpdateUserField,
  watchSetUserPhantom,
  watchSetUserEmailVerified,
} from './update-user-fields';

export default (config: RootSagaConfig = {} as RootSagaConfig) =>
  function* rootSaga(): Generator<unknown, void, unknown> {
    yield all([
      watchBulkActions(config),
      watchCreateLicense(config),
      watchFetchAllUsers(config),
      watchFetchSearchUsers(config),
      watchFetchLicenses(config),
      watchSearchLicenses(config),
      watchCheckCostCenterName(config),
      watchVerifyUsersEmails(config),
      watchFetchCostCentersByUser(config),
      watchUnPhantomUsers(config),
      watchFetchProductVersions(config),
      watchUpdateProductWhitelist(config),
      watchCreateProductVersion(config),
      watchUpdateProductAssets(config),
      watchUpdateProductActive(config),
      watchFetchProductFeatures(config),
      watchFetchSeatFeatures(config),
      watchSetSeatFeature(config),
      watchUpdateUserField(config),
      watchSetUserPhantom(config),
      watchSetUserEmailVerified(config),
      watchArchiveActiveEot(config),
      watchFetchActiveEot(config),
    ]);
  };
